export default __webpack_public_path__ + "static/media/rcclogo.2f174b3c.png";